// extracted by mini-css-extract-plugin
module.exports = {"root":"PlasmicFilterList_root__zTklX","filterListItem":"PlasmicFilterList_filterListItem__Py2UP"};